import PBFRoute from '@/screens/Order/PBFRoute'

export default function PBFLayout() {
  return <PBFRoute />
}
